import React from "react";

interface Skill {
  name: string;
  category: "frontend" | "backend" | "tools" | "other";
}

const Skills: React.FC = () => {
  const skills: Skill[] = [
    { name: "Automation", category: "other" },
    { name: "Artificial Intelligence", category: "other" },
    { name: "Maatwerk software", category: "other" },
  ];

  const getSkillColor = (index: number): { bg: string; shadow: string } => {
    const colors = [
      { bg: "#FF006E", shadow: "#000000" }, // Hot Pink
      { bg: "#FFD600", shadow: "#000000" }, // Yellow
      { bg: "#00F5FF", shadow: "#000000" }, // Cyan
      { bg: "#39FF14", shadow: "#000000" }, // Lime Green
      { bg: "#FF6B00", shadow: "#000000" }, // Orange
      { bg: "#9D00FF", shadow: "#000000" }, // Purple
      { bg: "#FF0055", shadow: "#000000" }, // Deep Pink
      { bg: "#00FF94", shadow: "#000000" }, // Mint Green
    ];
    return colors[index % colors.length];
  };

  return (
    <div className="skills-container">
      <div className="skills-pills">
        {skills.map((skill, index) => {
          const colors = getSkillColor(index);
          return (
            <span
              key={index}
              className="skill-pill"
              style={{
                border: `4px solid #000000`,
                backgroundColor: colors.bg,
                color: "#000000",
                boxShadow: `5px 5px 0px ${colors.shadow}`,
              }}
            >
              {skill.name}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default Skills;
